import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import Vuelidate from 'vuelidate'
import VueConfirmDialog from 'vue-confirm-dialog'

import './assets/css/main.css';

import moment from 'moment'

Vue.prototype.moment = moment
Vue.config.productionTip = false
Vue.use(Vuelidate);
Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
